"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CiPortalApi = exports.CI_PORTAL_API_MAX_PAGE_LENGTH = void 0;
const auth_manager_1 = require("../auth/auth-manager");
exports.CI_PORTAL_API_MAX_PAGE_LENGTH = Math.floor(2147483647);
class CiPortalApi {
    /**
     * @constructor
     */
    constructor(_verbose, _connector, company, project, projectTracking, projectStatus, projectInvoice, projectForecast, projectForecastType, projectOrder, 
    // options: CiPortalApiOptions,
    authEvents) {
        this._verbose = _verbose;
        this._connector = _connector;
        this.company = company;
        this.project = project;
        this.projectTracking = projectTracking;
        this.projectStatus = projectStatus;
        this.projectInvoice = projectInvoice;
        this.projectForecast = projectForecast;
        this.projectForecastType = projectForecastType;
        this.projectOrder = projectOrder;
        this.authEvents = authEvents;
    }
    get status() {
        return this._connector.authManager.status;
    }
    get authToken() {
        switch (this.status.type) {
            case auth_manager_1.AUTH_STATUS_TYPE.LOGGED_IN:
            case auth_manager_1.AUTH_STATUS_TYPE.REFRESHING:
                return this.status.payload.token;
        }
        return null;
    }
    /**
     * Manually provide user details to login to the API
     * TODO: need to be able to provide a signal to abort this request
     */
    login(arg) {
        return this._connector.authManager.rebaseLogin(arg);
    }
    /**
     * Provide a way to log the user out and reset the credentials
     */
    logout() {
        return this._connector.authManager.logout();
    }
    /**
     * Provide a way to log the user out and reset the credentials
     * TODO: need to be able to provide a signal to abort this request
     */
    requestPasswordChangeEmail(body) {
        return this._connector.authManager.requestPasswordChangeEmail(body);
    }
    /**
     * Provide a way to log the user out and reset the credentials
     * TODO: need to be able to provide a signal to abort this request
     */
    changePassword(body) {
        return this._connector.authManager.changePassword(body);
    }
    /**
     * @description
     * Raw fetch request to CiPortal API endpoint
     *
     * @param url
     * @param method
     * @param opts
     */
    apiFetch(url, method, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._connector.apiFetch(url, method, opts);
        });
    }
    /**
     * @description
     * Raw fetch request to CiPortal API endpoint
     *
     * @param url
     * @param method
     * @param opts
     */
    apiFetchBlob(url, method, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._connector.apiFetchBlob(url, method, opts);
        });
    }
    /**
     * @description
     * Fetch from a CiPortal API endpoint With authentication
     *
     * @param url
     * @param method
     * @param opts
     */
    apiFetchWithAuth(url, method, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._connector.apiFetchWithAuth(url, method, opts);
        });
    }
    /**
     * @description
     * Fetch from a CiPortal API endpoint With authentication
     *
     * @param url
     * @param method
     * @param opts
     */
    apiFetchBlobWithAuth(url, method, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._connector.apiFetchBlobWithAuth(url, method, opts);
        });
    }
}
exports.CiPortalApi = CiPortalApi;
CiPortalApi.MAX_PAGE_LENGTH = exports.CI_PORTAL_API_MAX_PAGE_LENGTH;
